// Importa el archivo CSS principal
import './main.css';

// Importa e inicializa Flowbite (asegúrate de haber instalado Flowbite)
import { initFlowbite, Dropdown } from 'flowbite';

// DOMPurify para sanitización de HTML inyectado vía innerHTML
import DOMPurify from 'dompurify';


// Import moment.js (previously loaded from CDN)
import moment from 'moment';
import 'moment/locale/es';
window.moment = moment;

// Import Handlebars (previously loaded from CDN)
import Handlebars from 'handlebars';
window.Handlebars = Handlebars;

// ApexCharts - lazy loaded in home.js, home-index2.js
// pdfjs-dist + pdf-lib - lazy loaded in gastos-reader.js, uploads-new.js
// XLSX - lazy loaded in import page modules

// Import html2pdf.js (previously loaded from CDN)
import html2pdf from 'html2pdf.js';
window.html2pdf = html2pdf;

// PJAX has been replaced with @hotwired/turbo (initialized in init.js)

// Store native setTimeout BEFORE pageLoader intercepts it.
// This allows showNotification to use untracked timeouts that won't be
// cleared when navigating between pages.
const nativeSetTimeout = window.setTimeout.bind(window);

import { initTracking } from './tracking.js';
import { initPageLoader, loadPageModule } from './pageLoader.js';
import { initApp } from './init.js';
import { initHeader } from './header.js';
// Imports moved to dynamic loading


// Init calls moved to bottom of file


// Importa el componente Datepicker de Flowbite
import Datepicker from "flowbite-datepicker/Datepicker";

// Importa Tom Select (vanilla JS select widget)
import TomSelect from 'tom-select';
// CSS se carga via CDN en header.php para evitar conflictos con sass-loader
window.TomSelect = TomSelect;
import Tagify from '@yaireo/tagify';
import '@yaireo/tagify/dist/tagify.css';

import Litepicker from 'litepicker';
window.Litepicker = Litepicker;

// Blur focused element before Flowbite hides modals to prevent
// "Blocked aria-hidden on an element because its descendant retained focus" warning
document.addEventListener('click', function(e) {
	if (e.target.closest('[data-modal-hide]') && document.activeElement) {
		document.activeElement.blur();
	}
}, true);

import flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import "flatpickr/dist/flatpickr.min.css";
window.flatpickr = flatpickr;



Datepicker.locales.es = {
	days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
	daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
	daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
	months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
	monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
	today: "Hoy",
	monthsTitle: "Meses",
	clear: "Borrar",
	weekStart: 1,
	format: "dd/mm/yyyy"
};


class Facturavia {

	/**
	 * Obtiene el token CSRF del meta tag o de la cookie csrf_token.
	 * @returns {string|null} Token CSRF o null si no existe
	 */
	static getCsrfToken() {
		return document.querySelector('meta[name="csrf-token"]')?.content
			|| document.cookie.split('; ').find(c => c.startsWith('csrf_token='))?.split('=')[1]
			|| null;
	}

	static flatpickr() {
		// DOM
		const input = document.getElementById("periodPickerInput");
		const popover = document.getElementById("periodPicker");
		const monthsWrap = document.getElementById("ppMonths");
		const calendarInlineHost = document.getElementById("ppCalendarInline");
		const calendarHiddenInput = document.getElementById("ppCalendarHiddenInput");

		const startInput = document.getElementById("ppStartDate");
		const endInput = document.getElementById("ppEndDate");

		if (!startInput || !endInput) return;
		if (!input || !popover || !monthsWrap || !calendarInlineHost || !calendarHiddenInput) return;

		// Prevent double-init on the same element (preload + page module both call this)
		if (input._ppInitialized) return;
		input._ppInitialized = true;

		// Cleanup previous instance (accumulated from prior navigations)
		if (Facturavia._ppAbort) Facturavia._ppAbort.abort();
		Facturavia._ppAbort = new AbortController();
		const _ppSignal = Facturavia._ppAbort.signal;

		if (Facturavia._ppFlatpickr) {
			try { Facturavia._ppFlatpickr.destroy(); } catch (_) {}
			Facturavia._ppFlatpickr = null;
		}

		// =========================
		// Cookie storage (PHP-friendly)
		// =========================
		const STORAGE_KEY = "fv_period_picker_v1";

		function cookieSet(name, value, days = 365) {
			const maxAge = days * 24 * 60 * 60;
			const secure = (location.protocol === "https:") ? "; Secure" : "";
			document.cookie =
				`${encodeURIComponent(name)}=${encodeURIComponent(value)}` +
				`; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
		}

		function cookieGet(name) {
			const n = encodeURIComponent(name) + "=";
			const parts = document.cookie.split("; ");
			for (const p of parts) {
				if (p.indexOf(n) === 0) return decodeURIComponent(p.substring(n.length));
			}
			return null;
		}

		function cookieDel(name) {
			const secure = (location.protocol === "https:") ? "; Secure" : "";
			document.cookie = `${encodeURIComponent(name)}=; Max-Age=0; Path=/; SameSite=Lax${secure}`;
		}

		function buildPeriodUrlFromCurrent(payload) {
			const url = new URL(window.location.href);

			// Limpia fechas anteriores
			url.searchParams.delete('start_date');
			url.searchParams.delete('end_date');

			if (payload?.mode === 'all') {
				url.searchParams.set('start_date', 'all');
				url.searchParams.delete('end_date');
			} else {
				if (payload?.start) url.searchParams.set('start_date', String(payload.start));
				if (payload?.end) url.searchParams.set('end_date', String(payload.end));
			}

			return url.pathname + url.search + url.hash;
		}



		function saveSelection(payload) {
			try {
				const data = {
					mode: payload.mode ?? null,
					start: payload.start ?? null,
					end: payload.end ?? null,
					label: payload.label ?? null,
					year: payload.year ?? null,
					q: payload.q ?? null,
					month: payload.month ?? null,
					ts: Date.now()
				};

				cookieSet(STORAGE_KEY, JSON.stringify(data), 365);

				const url = buildPeriodUrlFromCurrent(payload);

				// Partial fetch: only update #data if it exists
				var dataEl = document.getElementById('data');
				if (dataEl) {
					fetch(url, { headers: { 'Turbo-Frame': 'main' } })
						.then(function (res) { return res.text(); })
						.then(function (html) {
							var parser = new DOMParser();
							var doc = parser.parseFromString(html, 'text/html');
							var newData = doc.getElementById('data');
							if (newData) {
								dataEl.innerHTML = newData.innerHTML;
								dataEl.querySelectorAll('[data-pjax-update]').forEach(function (u) {
									var action = (u.dataset.pjaxUpdate || '').toString();
									var target = (u.dataset.target || '').toString();
									if (!action || !target) return;
									var t = document.querySelector(target);
									if (!t) return;
									var value = u.dataset.value || '';
									if (action === 'text') t.textContent = value;
									else if (action === 'html') t.innerHTML = value;
								});
								if (typeof window.iniciarFunciones === 'function') {
									window.iniciarFunciones();
								}
								Facturavia.loadComponents();
							}
							history.replaceState(null, '', url);
						})
						.catch(function () {
							Facturavia.link(url);
						});
				} else {
					Facturavia.link(url);
				}

			} catch (e) {
				console.error(e);
			}
		}

		function loadSelection() {
			try {
				const raw = cookieGet(STORAGE_KEY);
				if (!raw) return null;
				const v = JSON.parse(raw);
				if (!v || typeof v !== "object") return null;
				return v;
			} catch (_) {
				return null;
			}
		}

		function clearSavedSelection() {
			try { cookieDel(STORAGE_KEY); } catch (_) { }
		}

		// =========================
		// Helpers
		// =========================
		const fmtShortES = (d) => {
			const months = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
			return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
		};

		const pad2 = (n) => String(n).padStart(2, "0");
		const fmtYMDCompact = (d) => `${d.getFullYear()}${pad2(d.getMonth() + 1)}${pad2(d.getDate())}`;

		const startOfMonth = (y, m) => new Date(y, m, 1);
		const endOfMonth = (y, m) => new Date(y, m + 1, 0);
		const startOfYear = (y) => new Date(y, 0, 1);
		const endOfYear = (y) => new Date(y, 11, 31);

		const quarterRange = (y, q) => ({
			1: [new Date(y, 0, 1), new Date(y, 2, 31)],
			2: [new Date(y, 3, 1), new Date(y, 5, 30)],
			3: [new Date(y, 6, 1), new Date(y, 8, 30)],
			4: [new Date(y, 9, 1), new Date(y, 11, 31)],
		}[q]);

		const monthNamesES = [
			"Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
			"Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
		];

		const months = [
			{ label: "Ene", idx: 0 }, { label: "Feb", idx: 1 }, { label: "Mar", idx: 2 },
			{ label: "Abr", idx: 3 }, { label: "May", idx: 4 }, { label: "Jun", idx: 5 },
			{ label: "Jul", idx: 6 }, { label: "Ago", idx: 7 }, { label: "Sep", idx: 8 },
			{ label: "Oct", idx: 9 }, { label: "Nov", idx: 10 }, { label: "Dic", idx: 11 },
		];

		function parseCompactToDate(s) {
			if (!s || !/^\d{8}$/.test(s)) return null;
			const y = Number(s.slice(0, 4));
			const m = Number(s.slice(4, 6)) - 1;
			const d = Number(s.slice(6, 8));
			return new Date(y, m, d);
		}

		function getUrlRange() {
			const qs = new URLSearchParams(window.location.search);
			const start = (qs.get("start_date") || "").trim();
			const end = (qs.get("end_date") || "").trim();
			if (!/^\d{8}$/.test(start) || !/^\d{8}$/.test(end)) return null;
			return { start, end };
		}

		// =========================
		// State
		// =========================
		const now = new Date();
		let viewYear = now.getFullYear();
		let pendingCalendar = { start: null, end: null };
		let isHydrating = false;

		// =========================
		// Selection UI
		// =========================
		const ACTIVE_CLASS = "bg-black !text-white";

		function clearSelection() {
			popover.querySelectorAll("[data-q]").forEach(b => b.classList.remove(...ACTIVE_CLASS.split(" ")));
			popover.querySelectorAll("[data-pp-month]").forEach(b => b.classList.remove(...ACTIVE_CLASS.split(" ")));
			const yBtn = popover.querySelector('[data-action="year"]');
			const aBtn = popover.querySelector('[data-action="all"]');
			if (yBtn) yBtn.classList.remove(...ACTIVE_CLASS.split(" "));
			if (aBtn) aBtn.classList.remove(...ACTIVE_CLASS.split(" "));
		}

		function setSelected(payload) {
			clearSelection();

			if (payload.mode === "quarter") {
				const qBtn = popover.querySelector(`[data-q="${payload.q}"]`);
				if (qBtn) qBtn.classList.add(...ACTIVE_CLASS.split(" "));
				return;
			}

			if (payload.mode === "month") {
				const mBtn = popover.querySelector(`[data-pp-month="${payload.month}"]`);
				if (mBtn) mBtn.classList.add(...ACTIVE_CLASS.split(" "));
				return;
			}

			if (payload.mode === "year") {
				const yBtn = popover.querySelector('[data-action="year"]');
				if (yBtn) yBtn.classList.add(...ACTIVE_CLASS.split(" "));
				return;
			}

			if (payload.mode === "all") {
				const aBtn = popover.querySelector('[data-action="all"]');
				if (aBtn) aBtn.classList.add(...ACTIVE_CLASS.split(" "));
				return;
			}
		}

		// =========================
		// Input UI + apply (NO navegación)
		// =========================
		function setInputValue({ mode, label }) {
			if (label && label.trim() !== "") {
				input.value = label;
				return;
			}
			if (mode === "all") {
				input.value = "Todos los años";
				return;
			}
			input.value = "";
		}

		const onChange = (payload, opts = {}) => {
			setSelected(payload);

			// no guardar durante hidratación
			if (opts.silent || isHydrating) return;

			// ✅ guardar en COOKIE para que PHP lo use al recargar
			saveSelection(payload);
		};

		function apply(payload, opts = {}) {
			setInputValue(payload);
			onChange(payload, opts);
		}

		// =========================
		// Render UI
		// =========================
		function renderYears() {
			popover.querySelector('[data-year-slot="-1"]').textContent = String(viewYear - 1);
			popover.querySelector('[data-year-slot="0"]').textContent = String(viewYear);
			popover.querySelector('[data-year-slot="+1"]').textContent = String(viewYear + 1);
			popover.querySelector('[data-bind="yearLabel"]').textContent = String(viewYear);
		}

		function renderMonths() {
			monthsWrap.innerHTML = "";
			months.forEach((m) => {
				const btn = document.createElement("button");
				btn.type = "button";
				btn.dataset.ppMonth = String(m.idx);
				btn.className = "px-3 py-2 rounded-lg hover:bg-gray-100 text-sm text-gray-900 w-[60px]";
				btn.textContent = m.label;

				btn.addEventListener("click", () => {
					const s = startOfMonth(viewYear, m.idx);
					const e = endOfMonth(viewYear, m.idx);

					apply({
						mode: "month",
						month: m.idx,
						start: fmtYMDCompact(s),
						end: fmtYMDCompact(e),
						year: viewYear,
						label: `${monthNamesES[m.idx]} ${viewYear}`,
					});

					closePopover();
				});

				monthsWrap.appendChild(btn);
			});
		}

		function setTab(tab) {
			const tabs = popover.querySelectorAll("[data-tab]");
			const panels = popover.querySelectorAll("[data-panel]");

			tabs.forEach((t) => {
				const isActive = t.dataset.tab === tab;
				t.classList.toggle("text-gray-900", isActive);
				t.classList.toggle("text-gray-400", !isActive);
				t.classList.toggle("border-gray-900", isActive);
				t.classList.toggle("border-transparent", !isActive);
				t.classList.toggle("border-b-2", true);
			});

			panels.forEach((p) => p.classList.toggle("hidden", p.dataset.panel !== tab));
		}

		function openPopover() {
			const rect = input.getBoundingClientRect();
			popover.style.left = rect.left + window.scrollX + "px";
			popover.style.top = rect.bottom + window.scrollY + "px";
			popover.classList.remove("hidden");
		}

		function closePopover() {
			popover.classList.add("hidden");
		}

		function isOpen() {
			return !popover.classList.contains("hidden");
		}

		// =========================
		// Flatpickr inline
		// =========================
		const fp = Facturavia._ppFlatpickr = flatpickr(calendarHiddenInput, {
			locale: Spanish,
			mode: "range",
			dateFormat: "Y-m-d",
			inline: true,
			appendTo: calendarInlineHost,
			clickOpens: false,
			enableTime: false,
			noCalendar: false,
			disableMobile: true,
			showMonths: 1,

			onReady: function (_, __, instance) {
				const timeWrap = instance.calendarContainer.querySelector(".flatpickr-time");
				if (timeWrap) timeWrap.style.display = "none";
			},

			onChange: (selectedDates) => {
				pendingCalendar.start = selectedDates[0] || null;
				pendingCalendar.end = selectedDates[1] || null;

				startInput.value = pendingCalendar.start ? fmtShortES(pendingCalendar.start) : "";
				endInput.value = pendingCalendar.end ? fmtShortES(pendingCalendar.end) : "";
			},
		});

		// =========================
		// Hydration (URL > Cookie)
		// =========================
		function hydrateRangeCompact(start, end) {
			const sd = parseCompactToDate(start);
			const ed = parseCompactToDate(end);
			if (!sd || !ed) return false;

			isHydrating = true;
			try {
				viewYear = sd.getFullYear();
				renderYears();
				renderMonths();

				fp.setDate([sd, ed], false);
				fp.jumpToDate(sd);

				pendingCalendar.start = sd;
				pendingCalendar.end = ed;
				startInput.value = fmtShortES(sd);
				endInput.value = fmtShortES(ed);

				const y = sd.getFullYear();

				// Año exacto
				if (start === fmtYMDCompact(startOfYear(y)) && end === fmtYMDCompact(endOfYear(y))) {
					apply({ mode: "year", start, end, year: y, label: `Año ${y}` }, { silent: true });
					return true;
				}

				// Trimestre exacto
				for (let q = 1; q <= 4; q++) {
					const [qsD, qeD] = quarterRange(y, q);
					if (start === fmtYMDCompact(qsD) && end === fmtYMDCompact(qeD)) {
						apply({ mode: "quarter", q, start, end, year: y, label: `${q}T ${y}` }, { silent: true });
						return true;
					}
				}

				// Mes exacto
				const m = sd.getMonth();
				if (start === fmtYMDCompact(startOfMonth(y, m)) && end === fmtYMDCompact(endOfMonth(y, m))) {
					apply({ mode: "month", month: m, start, end, year: y, label: `${monthNamesES[m]} ${y}` }, { silent: true });
					return true;
				}

				// Personalizado
				apply({ mode: "calendar", start, end, year: y, label: `${fmtShortES(sd)} - ${fmtShortES(ed)}` }, { silent: true });
				return true;

			} finally {
				isHydrating = false;
			}
		}

		function hydrateFromUrl() {
			const r = getUrlRange();
			if (!r) return false;
			return hydrateRangeCompact(r.start, r.end);
		}

		function hydrateFromCookie() {
			const saved = loadSelection();
			if (!saved) return false;

			// soporta "all" (solo UI)
			if (saved.mode === "all") {
				isHydrating = true;
				try {
					apply({ mode: "all", start: null, end: null, year: null, label: "Todos los años" }, { silent: true });
					return true;
				} finally {
					isHydrating = false;
				}
			}

			if (!saved.start || !saved.end) return false;
			return hydrateRangeCompact(saved.start, saved.end);
		}

		// =========================
		// Events
		// =========================
		input.addEventListener("click", () => (isOpen() ? closePopover() : openPopover()));

		// Click-outside is handled globally in preload() click listener
		// to avoid AbortController/timing issues with Turbo navigations.

		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && isOpen()) closePopover();
		}, { signal: _ppSignal });

		popover.querySelectorAll("[data-year-nav]").forEach((btn) => {
			btn.addEventListener("click", () => {
				viewYear += btn.dataset.yearNav === "+1" ? 1 : -1;
				renderYears();
				renderMonths();
			});
		});

		popover.querySelectorAll("[data-q]").forEach((btn) => {
			btn.addEventListener("click", () => {
				const q = Number(btn.dataset.q);
				const [s, e] = quarterRange(viewYear, q);

				apply({
					mode: "quarter",
					q,
					start: fmtYMDCompact(s),
					end: fmtYMDCompact(e),
					year: viewYear,
					label: `${q}T ${viewYear}`,
				});

				closePopover();
			});
		});

		popover.querySelectorAll("[data-action]").forEach((btn) => {
			btn.addEventListener("click", () => {
				const action = btn.dataset.action;

				if (action === "year") {
					const s = startOfYear(viewYear);
					const e = endOfYear(viewYear);
					apply({
						mode: "year",
						start: fmtYMDCompact(s),
						end: fmtYMDCompact(e),
						year: viewYear,
						label: `Año ${viewYear}`,
					});
					closePopover();
					return;
				}

				if (action === "all") {
					apply({ mode: "all", start: null, end: null, year: null, label: "Todos los años" });
					closePopover();
					return;
				}

				if (action === "clear") {
					pendingCalendar = { start: null, end: null };
					fp.clear();
					startInput.value = "";
					endInput.value = "";
					clearSavedSelection();
					apply({ mode: "", start: null, end: null, year: null, label: "" }, { silent: true });
					return;
				}

				if (action === "apply") {
					if (!pendingCalendar.start || !pendingCalendar.end) return;

					const startCompact = fmtYMDCompact(pendingCalendar.start);
					const endCompact = fmtYMDCompact(pendingCalendar.end);

					const startUI = fmtShortES(pendingCalendar.start);
					const endUI = fmtShortES(pendingCalendar.end);

					apply({
						mode: "calendar",
						start: startCompact,
						end: endCompact,
						year: pendingCalendar.start.getFullYear(),
						label: `${startUI} - ${endUI}`,
					});

					closePopover();
					return;
				}
			});
		});

		popover.querySelectorAll("[data-tab]").forEach((btn) => {
			btn.addEventListener("click", () => setTab(btn.dataset.tab));
		});

		// =========================
		// Init
		// =========================
		renderYears();
		renderMonths();
		setTab("periods");

		// Prioridad: URL > Cookie
		if (!hydrateFromUrl()) {
			hydrateFromCookie();
		}
	}






	static togglepassword(item) {
		const parent = item.parentElement;
		const input = parent.querySelector('input');
		const svgs = item.querySelectorAll('svg');
		if (input.getAttribute('type') === 'password') {
			input.setAttribute('type', 'text');
			if (svgs[0]) svgs[0].classList.remove('hidden');
			if (svgs[1]) svgs[1].classList.add('hidden');
		} else {
			input.setAttribute('type', 'password');
			if (svgs[1]) svgs[1].classList.remove('hidden');
			if (svgs[0]) svgs[0].classList.add('hidden');
		}
	}

	static closemenu() {
		document.body.classList.remove('overflow-hidden');
		const mainmenu = document.getElementById('mainmenu');
		if (mainmenu) mainmenu.classList.add('ml-[-100%]');
	}

	static openmenu() {
		document.body.classList.add('overflow-hidden');
		const mainmenu = document.getElementById('mainmenu');
		if (mainmenu) mainmenu.classList.remove('ml-[-100%]');
	}

	static modalClose() {
		const modalLoad = document.getElementById('modalLoad');
		if (modalLoad) {
			modalLoad.classList.add('hidden');
			modalLoad.classList.remove('fixed');
		}
		document.body.classList.remove('overflow-hidden');
	}

	static confirm(options) {
		// defaults
		const defaults = {
			title: 'Confirmación',
			message: '¿Estás seguro?',
			confirmText: 'Confirmar',
			cancelText: 'Cancelar',
			type: 'danger', // or 'primary'
			onConfirm: () => { }
		};
		const settings = { ...defaults, ...options };

		let modal = document.getElementById('facturavia-confirm-modal');
		if (!modal) {
			const modalHtml = `
            <div id="facturavia-confirm-modal" class="modal top-0 left-0 justify-center items-center flex w-full h-full lg:bg-[#89898975] z-[9999] hidden fixed">
                <div class="bg-white h-auto w-[450px] max-w-full pb-5 mx-3 rounded-lg px-[19px]">
                    <div class="flex justify-between items-center lg:text-left mb-[16px] relative mt-[16px]">
                        <h5 id="confirm-title" class="text-black font-semibold text-[18px] lg:text-lg lg:text-left"></h5>
                        <div class="m-2 mx-0 cursor-pointer flex items-center close-confirm">
                            <div class="">
                                <svg class="w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="confirm-message" class="mb-[25px] text-[14px]"></div>
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
                            <div class="my-auto order-2 lg:order-1">
                                <button id="confirm-cancel-btn" class="w-full px-[24px] rounded-lg bg-[#fff] border border-[#eee] text-[#000] py-2 hover:bg-[#fafafa]"></button>
                            </div>
                            <div class="order-1 lg:order-2">
                                <button id="confirm-ok-btn" class="w-full px-[24px] rounded-lg text-white py-2"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;
			document.body.insertAdjacentHTML('beforeend', modalHtml);
			modal = document.getElementById('facturavia-confirm-modal');
		}

		// Set content
		const titleEl = document.getElementById('confirm-title');
		const messageEl = document.getElementById('confirm-message');
		const cancelBtn = document.getElementById('confirm-cancel-btn');
		const okBtn = document.getElementById('confirm-ok-btn');

		if (titleEl) titleEl.textContent = settings.title;
		if (messageEl) messageEl.textContent = settings.message;
		if (cancelBtn) cancelBtn.textContent = settings.cancelText;
		if (okBtn) okBtn.textContent = settings.confirmText;

		// Style button based on type
		const dangerClasses = ['bg-[#f12525]', 'border-[#f12525]', 'hover:bg-[#d35050]', 'lg:bg-[#f12525]', 'lg:border-[#f12525]'];
		const warningClasses = ['bg-[#f59e0b]', 'border-[#f59e0b]', 'hover:bg-[#d97706]', 'lg:bg-[#f59e0b]', 'lg:border-[#f59e0b]'];
		const primaryClasses = ['bg-[#000]', 'hover:bg-opacity-80'];
		const allTypeClasses = [...dangerClasses, ...warningClasses, ...primaryClasses];

		if (okBtn) {
			allTypeClasses.forEach(cls => okBtn.classList.remove(cls));
			if (settings.type === 'danger') {
				dangerClasses.forEach(cls => okBtn.classList.add(cls));
			} else if (settings.type === 'warning') {
				warningClasses.forEach(cls => okBtn.classList.add(cls));
			} else {
				primaryClasses.forEach(cls => okBtn.classList.add(cls));
			}
		}

		// Event handlers
		const close = () => {
			modal.classList.add('hidden');
			modal.classList.remove('fixed');
			document.body.classList.remove('overflow-hidden');
		};

		const cancel = () => {
			close();
			if (typeof settings.onCancel === 'function') {
				settings.onCancel();
			}
		};

		// Remove old listeners by cloning elements
		const closeConfirmEls = modal.querySelectorAll('.close-confirm, #confirm-cancel-btn');
		closeConfirmEls.forEach(el => {
			const newEl = el.cloneNode(true);
			el.parentNode.replaceChild(newEl, el);
			newEl.addEventListener('click', cancel);
		});

		// Re-get okBtn after potential clone
		const newOkBtn = document.getElementById('confirm-ok-btn');
		if (newOkBtn) {
			const clonedOkBtn = newOkBtn.cloneNode(true);
			newOkBtn.parentNode.replaceChild(clonedOkBtn, newOkBtn);
			clonedOkBtn.addEventListener('click', function () {
				if (typeof settings.onConfirm === 'function') {
					settings.onConfirm();
				}
				close();
			});
		}

		modal.classList.remove('hidden');
		modal.classList.add('fixed');
		document.body.classList.add('overflow-hidden');
	}

	static modal(name, parms = {}) {
		const modalContent = document.getElementById('modalContent');
		if (modalContent) modalContent.innerHTML = '';

		// Asegurarse de que parms sea un objeto
		parms = parms || {};

		// Asegurarse de que parms.data sea un objeto
		if (parms.data == null) {
			parms.data = {};
		}

		const modalLoad = document.getElementById('modalLoad');
		if (modalLoad) {
			modalLoad.classList.remove('hidden');
			modalLoad.classList.add('fixed');
		}
		document.body.classList.add('overflow-hidden');

		// Build query string from data
		const queryParams = new URLSearchParams(parms.data).toString();
		const url = '/html/' + name + (queryParams ? '?' + queryParams : '');

		fetch(url, { method: 'GET' })
			.then(response => response.json())
			.then(d => {
				if (modalContent) {
					modalContent.innerHTML = DOMPurify.sanitize(d.content, { ADD_TAGS: ['turbo-frame', 'use'], ADD_ATTR: ['data-page', 'data-id', 'data-name', 'data-turbo-frame', 'data-action', 'data-action-param', 'data-modal-data', 'href', 'xlink:href'] });
					// If modal content has a data-page attribute, load the corresponding module
					const pageEl = modalContent.querySelector('[data-page]');
					if (pageEl && pageEl.dataset.page) {
						loadPageModule(pageEl.dataset.page, true);
					}
				}
			})
			.catch(error => {
				console.error('Error loading modal:', error);
			});
	}

	static link(url) {
		var frame = document.getElementById('main');
		if (frame) {
			var a = document.createElement('a');
			a.href = url;
			a.setAttribute('data-turbo-frame', 'main');
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
			a.remove();
		} else {
			document.location.href = url;
		}
	}

	static loadComponents() {
		const userAgent = navigator.userAgent;
		const isWindows = userAgent.indexOf('Windows') !== -1;
		const isLinux = userAgent.indexOf('Linux') !== -1;
		const isMacDesktop = /Macintosh|Mac OS X/.test(userAgent) && !/iPhone|iPad|iPod/.test(userAgent);

		// Manejo de calendarios simples
		const calendars = document.getElementsByClassName('calendar');
		for (let i = 0; i < calendars.length; i++) {
			const calendarEl = calendars[i];

			// Evitar cargar componentes si ya están inicializados
			if (!calendarEl._calendarInitialized) {
				const input = calendarEl.querySelector('input');
				if (!input) continue;

				if (isWindows || isLinux || isMacDesktop) {
					input.setAttribute('type', 'text');
					const data = input.value;
					const min = input.getAttribute('min');
					const max = input.getAttribute('max');

					const minDate = min ? new Date(min) : null;
					const maxDate = max ? new Date(max) : null;

					if (data) {
						const date = moment(data).format('D/MM/Y');
						input.value = date;
					}

					const calendar = new Datepicker(input, {
						language: 'es',
						autohide: true,
						minDate,
						maxDate
					});

					calendarEl._calendarInitialized = true;
					calendarEl._calendar = calendar;

				} else {
					input.setAttribute('type', 'date');
				}
			}
		}

		// Manejo de calendarios con rango
		const calendarRanges = document.getElementsByClassName('calendar-range');
		for (let i = 0; i < calendarRanges.length; i++) {
			const calendarEl = calendarRanges[i];

			// Evitar cargar componentes si ya están inicializados
			if (!calendarEl._calendarRangeInitialized) {
				const input = calendarEl.querySelector('input');
				if (!input) continue;

				const data = input.value;
				const min = input.getAttribute('min');
				const max = input.getAttribute('max');

				const minDate = min ? new Date(min) : null;
				const maxDate = max ? new Date(max) : null;

				if (data) {
					const date = moment(data).format('D/MM/Y');
					input.value = date;
				}

				const calendar = new Datepicker(input, {
					language: 'es',
					autohide: true,
					minDate,
					maxDate,
					rangePicker: true,
				});

				calendarEl._calendarRangeInitialized = true;
				calendarEl._calendarRange = calendar;
			}
		}

		// Manejo de dropdowns
		const dropdownButtons = document.getElementsByClassName('dropdownButton');
		const dropdownMenus = document.getElementsByClassName('dropdownMenu');

		for (let i = 0; i < dropdownButtons.length; i++) {
			const dropdownButtonEl = dropdownButtons[i];

			// Evitar recargar el dropdown si ya está inicializado
			if (!dropdownButtonEl._dropdownInitialized) {
				const menuEl = dropdownMenus[i];
				if (!menuEl) continue;
				const dropdown = new Dropdown(menuEl, dropdownButtons[i], {
					placement: 'bottom',
					triggerType: 'click',
					offsetSkidding: 0,
					offsetDistance: 10,
					delay: 300,
					ignoreClickOutsideClass: false,
					onHide: () => {
						if (menuEl.contains(document.activeElement)) {
							document.activeElement.blur();
						}
					},
					onShow: () => {
						// Callback opcional
					},
					onToggle: () => {
						// Callback opcional
					},
				});

				// Guardar instancia en los datos del botón
				dropdownButtonEl._dropdownInitialized = true;
				dropdownButtonEl._dropdown = dropdown;
			}
		}

		// Blur any focused element trapped inside a hidden dropdown menu
		for (let i = 0; i < dropdownMenus.length; i++) {
			if (dropdownMenus[i].contains(document.activeElement)) {
				document.activeElement.blur();
			}
		}

		// Manejo de dropdowns con data-dropdown-toggle (estilo Flowbite)
		const flowbiteDropdowns = document.querySelectorAll('[data-dropdown-toggle]');
		flowbiteDropdowns.forEach(triggerEl => {
			const targetId = triggerEl.getAttribute('data-dropdown-toggle');
			const targetEl = document.getElementById(targetId);
			if (!targetEl) {
				return;
			}

			// Destruir instancia anterior si existe
			if (triggerEl._flowbiteDropdown) {
				try {
					triggerEl._flowbiteDropdown.destroy();
				} catch (e) {
					// Ignorar errores de destrucción
				}
				triggerEl._flowbiteDropdown = null;
				triggerEl._flowbiteDropdownInitialized = false;
			}

			const dropdown = new Dropdown(targetEl, triggerEl, {
				placement: 'bottom',
				triggerType: 'click',
				offsetSkidding: 0,
				offsetDistance: 10,
				onHide: () => {
					if (targetEl.contains(document.activeElement)) {
						document.activeElement.blur();
					}
				},
			});

			triggerEl._flowbiteDropdownInitialized = true;
			triggerEl._flowbiteDropdown = dropdown;
		});
	}



	static preload() {
		initFlowbite();
		Facturavia.loadComponents();
		Facturavia.flatpickr();

		// Auto-setup sliders from data attributes (runs before page module)
		document.querySelectorAll('[data-open-slider]').forEach(function(btn) {
			var sliderId = btn.getAttribute('data-open-slider');
			var closeId = btn.getAttribute('data-close-slider') || '';
			if (sliderId && btn.id) {
				Facturavia.setupSlider(sliderId, btn.id, closeId);
			}
		});

		// Synchronous wiring for the documents-sent_item "Assign" slider.
		// The page module loads async, so a click on the per-row "Asignar"
		// button can arrive before its listener is attached. Wire it here
		// (delegated, idempotent via dataset guard) so the first click always
		// opens the panel.
		(function () {
			var slidingPanel = document.getElementById('slidingPanel');
			var slidingBackground = document.getElementById('slidingBackground');
			if (!slidingPanel || !slidingBackground) return;
			if (slidingPanel.dataset.dssWired === '1') return;
			slidingPanel.dataset.dssWired = '1';

			function openPanel() {
				slidingPanel.classList.remove('translate-x-full');
				slidingPanel.classList.add('translate-x-0');
				slidingBackground.classList.remove('hidden');
				setTimeout(function () {
					slidingBackground.classList.add('bg-[#0006]', 'backdrop-blur-[4px]');
					slidingBackground.classList.remove('bg-[#0000]', 'backdrop-blur-0');
				}, 10);
			}

			function closePanel() {
				slidingPanel.classList.remove('translate-x-0');
				slidingPanel.classList.add('translate-x-full');
				slidingBackground.classList.add('bg-[#0000]', 'backdrop-blur-0');
				slidingBackground.classList.remove('bg-[#0006]', 'backdrop-blur-[4px]');
				setTimeout(function () { slidingBackground.classList.add('hidden'); }, 500);
			}

			window.__openAssignSlider = function (fileId, fileName) {
				if (!fileId) return;
				var label = document.getElementById('assignFilesLabel');
				var ids = document.getElementById('assignFileIds');
				if (label) label.textContent = fileName || ('Archivo ' + fileId);
				if (ids) ids.value = JSON.stringify([fileId]);
				if (typeof window.__onAssignSliderOpen === 'function') {
					try { window.__onAssignSliderOpen(); } catch (e) {}
				}
				openPanel();
			};
			window.closeSlider = closePanel;

			document.addEventListener('click', function (e) {
				var el = e.target.closest('[data-action="openSliderSingle"]');
				if (!el) return;
				e.preventDefault();
				var fid = String(el.getAttribute('data-file-id') || '').trim();
				var fn = String(el.getAttribute('data-file-name') || '').trim();
				window.__openAssignSlider(fid, fn);
			}, true);

			slidingBackground.addEventListener('click', closePanel);
		})();

		// Use event delegation for document clicks (register only once)
		if (!Facturavia._preloadClickListenerAdded) {
			Facturavia._preloadClickListenerAdded = true;
			document.addEventListener('click', function (event) {
				const target = event.target;

				// Period picker: close when clicking outside
				if (!target.closest('#periodPicker,#periodPickerInput')) {
					const pp = document.getElementById('periodPicker');
					if (pp && !pp.classList.contains('hidden')) {
						pp.classList.add('hidden');
					}
				}

				// Account menu 1
				if (!target.closest('#accountmenu,#baccountmenu')) {
					const accountmenu = document.getElementById('accountmenu');
					const baccountmenu = document.getElementById('baccountmenu');
					if (accountmenu) accountmenu.classList.add('hidden');
					if (baccountmenu) {
						const icon = baccountmenu.querySelector('.icon');
						if (icon) icon.classList.remove('rotate-180');
						baccountmenu.classList.remove('bg-[#eee]');
						baccountmenu.classList.add('lg:hover:bg-[#fafafa]');
					}
				}

				// Account menu 2
				if (!target.closest('#accountmenu2,#baccountmenu2')) {
					const accountmenu2 = document.getElementById('accountmenu2');
					const baccountmenu2 = document.getElementById('baccountmenu2');
					if (accountmenu2) accountmenu2.classList.add('hidden');
					if (baccountmenu2) {
						baccountmenu2.classList.remove('bg-[#eee]');
						baccountmenu2.classList.add('lg:hover:bg-[#fafafa]');
					}
				}
			});
		}

		// Generic modal toggle — delegated so it works before page modules load
		if (!Facturavia._modalToggleDelegated) {
			Facturavia._modalToggleDelegated = true;
			document.addEventListener('click', function(e) {
				var btn = e.target.closest('[data-toggle-modal]');
				if (btn) {
					var modal = document.getElementById(btn.getAttribute('data-toggle-modal'));
					if (modal) {
						modal.classList.remove('hidden');
						modal.classList.add('fixed');
					}
					return;
				}
				var dismiss = e.target.closest('[data-dismiss-modal]');
				if (dismiss) {
					var modal = document.getElementById(dismiss.getAttribute('data-dismiss-modal'));
					if (modal) {
						modal.classList.add('hidden');
						modal.classList.remove('fixed');
					}
				}
			});
		}

		// Delete contact — delegated so it works before page module loads
		if (!Facturavia._removeContactDelegated) {
			Facturavia._removeContactDelegated = true;
			document.addEventListener('click', function(e) {
				var btn = e.target.closest('[data-action="removeContact"]');
				if (!btn) return;
				var id = btn.dataset.id;
				if (!id) return;
				Facturavia.disableButton(btn);
				Facturavia.make('deleteContact', { id: id }, function(d) {
					Facturavia.enableButton(btn);
					if (d.success === true) {
						Facturavia.showNotification({ message: 'Contacto eliminado correctamente', type: 'success' });
						Facturavia.link('/contactos/');
					}
				}, function() {
					Facturavia.enableButton(btn);
				});
			});
		}

		// Download period PDF — delegated so it works before page module loads
		if (!Facturavia._downloadPeriodPdfDelegated) {
			Facturavia._downloadPeriodPdfDelegated = true;
			document.addEventListener('click', function(e) {
				var btn = e.target.closest('.js-download-period-pdf');
				if (!btn || btn._downloadPeriodPdfBound) return;

				var typeFilter = btn.dataset.type;
				var startDate = btn.dataset.start;
				var endDate = btn.dataset.end;
				if (!typeFilter || !startDate || !endDate) return;

				e.preventDefault();

				Facturavia.disableButton(btn);

				var url = '/html/descargar-periodo-pdf?type=' + encodeURIComponent(typeFilter)
					+ '&start=' + encodeURIComponent(startDate)
					+ '&end=' + encodeURIComponent(endDate);

				fetch(url)
					.then(function(res) {
						if (!res.ok) {
							return res.text().then(function(msg) {
								throw new Error(msg || 'Error al descargar');
							});
						}
						return res.blob();
					})
					.then(function(blob) {
						var a = document.createElement('a');
						a.href = window.URL.createObjectURL(blob);
						var label = typeFilter === 'emitida' ? 'Emitidas' : 'Recibidas';
						a.download = label + '_' + startDate + '_' + endDate + '.zip';
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						window.URL.revokeObjectURL(a.href);
						Facturavia.enableButton(btn);
					})
					.catch(function(err) {
						Facturavia.enableButton(btn);
						Facturavia.showNotification({ message: err.message || 'Error al descargar.', type: 'error' });
					});
			});
		}

		// Slider close & clear-filters — global delegation (independent of page module)
		if (!Facturavia._sliderFiltersDelegated) {
			Facturavia._sliderFiltersDelegated = true;
			document.addEventListener('click', function(e) {
				var el;
				if ((el = e.target.closest('.js-clear-filters'))) {
					if (el.disabled) return;
					el.disabled = true;
					document.querySelectorAll('[data-filter-multi]').forEach(function(sel) {
						if (sel.tomselect) sel.tomselect.clear(true);
					});
					document.querySelectorAll('[data-filter]').forEach(function(inp) { inp.value = ''; });
					Facturavia.closeSliderPanel(el);
					var url = el.getAttribute('data-clear-url');
					if (url) Facturavia.link(url);
					return;
				}
				if ((el = e.target.closest('.js-close-slider'))) {
					Facturavia.closeSliderPanel(el);
					return;
				}
				if ((el = e.target.closest('.js-export-documents'))) {
					if (typeof window.exportDocuments === 'function') window.exportDocuments(el);
					return;
				}
			});
		}

		// Generic data-action delegation (handles clicks before page module loads).
		// Page modules expose key functions to window (e.g. window.confirmStep1).
		// This delegation calls them synchronously so buttons work on first load.
		if (!Facturavia._dataActionDelegated) {
			Facturavia._dataActionDelegated = true;
			document.addEventListener('click', function(e) {
				var el = e.target.closest('[data-action]');
				if (!el) return;
				// Skip on admin page — admin.js has its own delegation
				if (document.body.dataset.page === 'admin') return;
				// Skip elements with data params — page-specific delegation handles these
				if (el.dataset.taskId || el.dataset.employeeId || el.dataset.accountId || el.dataset.account || el.dataset.licenseId || el.dataset.invoiceId || el.dataset.id || el.dataset.id2 || el.dataset.param || el.dataset.url) return;
				var action = el.getAttribute('data-action');
				if (action && typeof window[action] === 'function') {
					e.preventDefault();
					window[action](el);
				}
			});
		}

		// Prevent native form submission for JS-handled forms (before page module loads)
		document.querySelectorAll('form[action="#"]').forEach(function(form) {
			if (!form._nativeSubmitBlocked) {
				form._nativeSubmitBlocked = true;
				form.addEventListener('submit', function(e) {
					e.preventDefault();
				});
			}
		});

		// Remove tagify elements
		document.querySelectorAll('.tagify').forEach(el => el.remove());

		// PDF modal viewer — global event delegation (registered once)
		if (!Facturavia._pdfModalListenerAdded) {
			Facturavia._pdfModalListenerAdded = true;
			document.addEventListener('click', function(e) {
				var btn = e.target.closest('.btn-view');
				if (btn) {
					var pdfModal = document.getElementById('pdfModal');
					if (!pdfModal) return;
					e.preventDefault();
					var url = btn.dataset.pdf || btn.getAttribute('href');
					if (!url) { alert('No se encontró la URL del PDF.'); return; }
					var pdfFrame = document.getElementById('pdfFrame');
					var pdfFallback = document.getElementById('pdfFallback');
					var pdfFallbackLink = document.getElementById('pdfFallbackLink');
					var pdfDownload = document.getElementById('pdfDownload');
					var canEmbed = !(/iPad|iPhone|iPod/.test(navigator.userAgent || '') && !window.MSStream);
					if (pdfFrame) pdfFrame.classList.toggle('hidden', !canEmbed);
					if (pdfFallback) pdfFallback.classList.toggle('hidden', canEmbed);
					document.body.classList.add('overflow-hidden');
					if (pdfFrame) pdfFrame.src = url;
					if (pdfDownload) pdfDownload.href = url;
					if (pdfFallbackLink) pdfFallbackLink.href = url;
					pdfModal.classList.remove('hidden');
					return;
				}
				if (e.target.id === 'pdfModalBack' || e.target.closest('#pdfClose')) {
					Facturavia.closePdfModal();
				}
			});
			document.addEventListener('keydown', function(ev) {
				if (ev.key === 'Escape' || ev.keyCode === 27) {
					Facturavia.closePdfModal();
				}
			});
		}
	}

	static closePdfModal() {
		var pdfModal = document.getElementById('pdfModal');
		if (!pdfModal || pdfModal.classList.contains('hidden')) return;
		document.body.classList.remove('overflow-hidden');
		var pdfFrame = document.getElementById('pdfFrame');
		if (pdfFrame) pdfFrame.src = 'about:blank';
		pdfModal.classList.add('hidden');
	}

	static triggerMenuAccount() {
		const accountmenu = document.getElementById('accountmenu');
		const baccountmenu = document.getElementById('baccountmenu');
		const icon = baccountmenu ? baccountmenu.querySelector('.icon') : null;

		if (accountmenu && accountmenu.classList.contains('hidden')) {
			accountmenu.classList.remove('hidden');
			if (icon) icon.classList.add('rotate-180');
			if (baccountmenu) {
				baccountmenu.classList.add('bg-[#eee]');
				baccountmenu.classList.remove('lg:hover:bg-[#fafafa]');
			}
		} else if (accountmenu) {
			accountmenu.classList.add('hidden');
			if (icon) icon.classList.remove('rotate-180');
			if (baccountmenu) {
				baccountmenu.classList.remove('bg-[#eee]');
				baccountmenu.classList.add('lg:hover:bg-[#fafafa]');
			}
		}
	}

	static triggerMenuBusiness() {
		const accountmenu2 = document.getElementById('accountmenu2');
		const baccountmenu2 = document.getElementById('baccountmenu2');
		const icon = baccountmenu2 ? baccountmenu2.querySelector('.icon') : null;

		if (accountmenu2 && accountmenu2.classList.contains('hidden')) {
			accountmenu2.classList.remove('hidden');
			if (icon) icon.classList.add('rotate-180');
			if (baccountmenu2) {
				baccountmenu2.classList.add('bg-[#eee]');
				baccountmenu2.classList.remove('lg:hover:bg-[#fafafa]');
			}
		} else if (accountmenu2) {
			accountmenu2.classList.add('hidden');
			if (icon) icon.classList.remove('rotate-180');
			if (baccountmenu2) {
				baccountmenu2.classList.remove('bg-[#eee]');
				baccountmenu2.classList.add('lg:hover:bg-[#fafafa]');
			}
		}
	}

	static filterSelect(item, name, parms = {}) {
		let searchValue = item.value;
		const currentUrl = new URL(window.location.href);
		let selector = 'main';

		if (typeof parms.selector !== 'undefined' && parms.selector !== null) {
			selector = parms.selector;
		}

		// Si el input es checkbox
		if (item.getAttribute('type') === 'checkbox') {
			searchValue = item.checked ? item.value : '';
		}

		// Si se pasa una función modificadora, se aplica al valor
		if (typeof parms.modifier === 'function') {
			searchValue = parms.modifier(searchValue);
		}

		// Añade o actualiza el parámetro en la URL
		currentUrl.searchParams.set(name, searchValue);

		// Elimina el offset si existe para volver a la página 1
		if (currentUrl.searchParams.has('offset')) {
			currentUrl.searchParams.delete('offset');
		}

		// Navigate using Turbo
		Facturavia.link(currentUrl.toString());
	}

	static filterSelectBetween(item, name, name2) {
		const searchValue = item.value;
		const currentUrl = new URL(window.location.href);

		if (searchValue === '') {
			// Elimina los parámetros si el valor está vacío
			currentUrl.searchParams.delete(name);
			currentUrl.searchParams.delete(name2);
		} else if (searchValue === 'custom') {
			const customcalendar = document.getElementById('customcalendar');
			if (customcalendar) {
				customcalendar.classList.remove('hidden');
				customcalendar._ref = item.id;
			}
			return false;
		} else {
			const dates = searchValue.split('-');
			const startDate = dates[0];
			const endDate = dates[1];

			// Verifica si el parámetro name ya existe
			if (!currentUrl.searchParams.has(name)) {
				// Añade el parámetro name con startDate
				currentUrl.searchParams.append(name, startDate);
			} else {
				// Actualiza el parámetro existente name con startDate
				currentUrl.searchParams.set(name, startDate);
			}

			// Verifica si el parámetro name2 ya existe
			if (!currentUrl.searchParams.has(name2)) {
				// Añade el parámetro name2 con endDate
				currentUrl.searchParams.append(name2, endDate);
			} else {
				// Actualiza el parámetro existente name2 con endDate
				currentUrl.searchParams.set(name2, endDate);
			}
		}

		// Elimina el offset si existe para volver a la página 1
		if (currentUrl.searchParams.has('offset')) {
			currentUrl.searchParams.delete('offset');
		}

		// Redirige a la nueva URL
		Facturavia.link(currentUrl.toString());
	}

	static formatPrice(numero) {
		return (numero / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}

	static handleFileUpload(target, options, callback) {
		const input = document.getElementById(target);
		if (!input) return;
		const parent = input.parentElement;

		// 1) Captura de drag & drop
		parent.addEventListener('dragover', function (e) {
			e.preventDefault();
			e.stopPropagation();
			this.classList.add('border-blue-500'); // destacar zona
		});

		parent.addEventListener('dragleave', function (e) {
			e.preventDefault();
			e.stopPropagation();
			this.classList.remove('border-blue-500');
		});

		parent.addEventListener('drop', function (e) {
			e.preventDefault();
			e.stopPropagation();
			this.classList.remove('border-blue-500');

			// Obtener ficheros
			const files = e.dataTransfer.files;
			if (!files.length) return;

			const file = files[0];
			// Comprobar tipo permitido
			if (!options.allowedTypes.includes(file.type)) {
				alert('Solo se permiten archivos PNG, JPG o PDF.');
				return;
			}

			// Asignar al input y disparar cambio
			input.files = files;
			const evt = new Event('change', { bubbles: true });
			input.dispatchEvent(evt);
		});

		// 2) Mismo flujo para selección por click o arrastre
		input.addEventListener('change', function (event) {
			const file = event.target.files[0];
			if (!file) return;

			// Mostrar loader
			const loading = parent.querySelector('.loading');
			const preupload = parent.querySelector('.preupload');
			if (loading) loading.classList.remove('hidden');
			if (preupload) preupload.classList.add('hidden');

			const formData = new FormData();
			formData.append('file', file);
			formData.append('action_type', 'tmp');

			const uploadHeaders = {};
			const uploadCsrf = Facturavia.getCsrfToken();
			if (uploadCsrf) uploadHeaders['X-CSRF-Token'] = uploadCsrf;

			fetch('/ajax/uploader', {
				method: 'POST',
				headers: uploadHeaders,
				body: formData
			})
				.then(function (response) { return response.json(); })
				.then(function (data) {
					callback(data);
				})
				.catch(function (error) {
					if (loading) loading.classList.add('hidden');
					console.error('Error:', error);
					alert('Error al subir la imagen.');
				});
		});
	}

	static convertirFormatoEspanolAEntero(numero) {
		// Reemplazar la coma por un punto
		let numeroConPunto = numero.replace(',', '.');

		// Convertir a número flotante y multiplicar por 100
		let numeroFlotante = parseFloat(numeroConPunto);
		let numeroEntero = Math.round(numeroFlotante * 100);

		return numeroEntero;
	}

	/**
	 * Maneja el envío de un formulario, integrando la función make.
	 * @param {Event} event - Evento submit del formulario.
	 * @param {HTMLFormElement} form - Elemento formulario.
	 * @param {function} onSuccess - Callback a ejecutar si el envío es exitoso.
	 * @param {function} onError - Callback a ejecutar si hay errores.
	 */
	static async form(event, form, onSuccess = () => { }, onError = () => { }, beforeSubmitOrOptions = null, options = {}) {
		event.preventDefault();

		// 5th param: si es función → beforeSubmit, si es objeto → options
		var beforeSubmit = async (data) => data;
		var opts = options || {};
		if (typeof beforeSubmitOrOptions === 'function') {
			beforeSubmit = beforeSubmitOrOptions;
		} else if (beforeSubmitOrOptions && typeof beforeSubmitOrOptions === 'object') {
			opts = beforeSubmitOrOptions;
		}

		if (!Facturavia.validateForm(form)) {
			onError([]);
			return false;
		}

		const formData = new FormData(form);
		var data = Facturavia.transformFormDataToNestedObject(form, formData);

		data = await beforeSubmit(data);

		const action = data.action;
		delete data.action;

		try {
			const result = await Facturavia.make(action, data, null, null, opts) || {};

			// Normalizar errores posibles
			const rootErrors = Array.isArray(result.errors) ? result.errors : [];
			var nestedErrors = [];
			if (result.data && action && result.data[action] && Array.isArray(result.data[action].errors)) {
				nestedErrors = result.data[action].errors;
			}
			const allErrors = rootErrors.concat(nestedErrors);

			if (allErrors.length > 0) {
				Facturavia.clearFormErrors(form);

				// Callback del usuario
				onError(allErrors);

				// Mostrar errores en el formulario.
				// Si result.data es null, los errores son de nivel raíz de GraphQL
				// y ya fueron mostrados por Facturavia.make() como notificación.
				if (result.data !== null) {
					allErrors.forEach(function (err) {
						// err.field puede no venir; intentamos inferirlo del mensaje
						var field = err.field;
						if (!field && err.message) {
							var m = err.message.match(/^([a-zA-Z0-9_\.]+)/);
							if (m && m[1]) {
								//field = m[1]; // p.ej. "document_ids"
							}
						}

						if (field) {
							Facturavia.showFormError(form, field, err.message || 'Error');
						} else {
							// Error genérico del formulario (reserva un contenedor global en tu UI)
							Facturavia.showFormError(form, '_global', err.message || 'Error');
						}
					});
				}
				return;
			}

			// Éxito
			Facturavia.clearFormErrors(form);
			onSuccess(result);
		} catch (e) {
			if (e && e.name === 'AbortError') return;
			// Errores de red, parseo o throw dentro de make()
			Facturavia.clearFormErrors(form);
			const fallback = [{ message: (e && e.message) ? e.message : 'Error inesperado' }];
			onError(fallback);
			Facturavia.showFormError(form, '_global', fallback[0].message);
		}
	}




	static serializeForm(form) {
		const formData = new FormData(form);
		return Facturavia.transformFormDataToNestedObject(form, formData);
	}

	static transformFormDataToNestedObject(form, formData) {
		const result = {};

		// Asegurar que todos los radios no seleccionados existan como clave con valor ""
		const allInputs = form.querySelectorAll('input, select, textarea');
		allInputs.forEach((input) => {
			if (input.type === 'radio') {
				if (!formData.has(input.name)) {
					Facturavia.assignNestedValue(result, input.name, "");
				}
			} else if (input.type === 'checkbox') {
				// Para los checkboxes no seleccionados, agregar valor false
				if (!formData.has(input.name)) {
					if (input.name.endsWith('[]')) {
						// Para checkboxes tipo array, inicializar como array vacío
						const baseKey = input.name.replace(/\[\]$/, '');
						if (!(baseKey in result)) {
							result[baseKey] = [];
						}
					} else {
						Facturavia.assignNestedValue(result, input.name, false);
					}
				}
			}
		});

		// Procesar los datos del FormData
		for (const [key, value] of formData.entries()) {
			let transformedValue = value;

			// Detectar si el valor es una fecha en formato español
			if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) { // Formato dd/mm/yyyy
				const [day, month, year] = value.split("/");
				transformedValue = `${year}-${month}-${day}`; // Convertir a yyyy-mm-dd
			}

			Facturavia.assignNestedValue(result, key, transformedValue);
		}

		return result;
	}

	static assignNestedValue(obj, path, value) {
		const keys = path.split('[').map(k => k.replace(']', ''));
		let current = obj;
		keys.forEach((key, index) => {
			if (index === keys.length - 1) {
				if (key === '' && Array.isArray(current)) {
					current.push(value);
				} else {
					current[key] = value;
				}
			} else {
				if (!current[key]) {
					current[key] = (keys[index + 1] === '') ? [] : {};
				}
				current = current[key];
			}
		});
	}


	static clearFormErrors(form) {
		// Remover mensajes de error y clases de estilo previas
		form.querySelectorAll('.error-message').forEach((el) => el.remove());
		form.querySelectorAll('.border-red-500').forEach((el) => el.classList.remove('border-red-500'));
	}

	static showFormError(form, fieldName, message) {

		if (fieldName == '_global') {
			Facturavia.showNotification({
				message: message,
				type: 'error'
			});
		} else {
			// Encontrar el campo con el error
			const field = form.querySelector(`[name="${fieldName}"]`);

			if (field) {
				// Aplicar estilo al borde
				field.classList.add('border-red-500');

				// Crear mensaje de error
				const errorMessage = document.createElement('div');
				errorMessage.className = 'error-message text-red-500 text-sm mt-1';
				errorMessage.textContent = message;

				// Insertar mensaje después del campo
				field.insertAdjacentElement('afterend', errorMessage);
			}
		}
	}

	/**
	 * Muestra un mensaje de error bajo un elemento.
	 * @param {HTMLElement} element - Elemento sobre el que mostrar el error.
	 * @param {string} message - Texto del mensaje de error.
	 */
	static showError(element, message) {
		// Guardar clase de borde original si no se ha guardado
		if (!element.dataset.originalBorderClass) {
			const borderClass = Array.from(element.classList).find(c =>
			(c.startsWith('border-') && c !== 'border' && c !== 'border-red-500'
				&& !c.startsWith('border-t') && !c.startsWith('border-b')
				&& !c.startsWith('border-l') && !c.startsWith('border-r'))
			);
			if (borderClass) {
				element.dataset.originalBorderClass = borderClass;
			}
		}

		// Eliminar clase de borde original y aplicar rojo
		if (element.dataset.originalBorderClass) {
			element.classList.remove(element.dataset.originalBorderClass);
		}
		element.classList.remove('border-gray-300');
		element.classList.add('border-red-500');

		// Quitar mensaje de error anterior si existe
		const nextSibling = element.nextElementSibling;
		if (nextSibling && nextSibling.classList.contains('error-message')) {
			nextSibling.remove();
		}

		// Crear y mostrar nuevo mensaje
		const errorDiv = document.createElement('div');
		errorDiv.className = 'error-message text-red-500 text-sm mt-1';
		errorDiv.textContent = message;

		element.insertAdjacentElement('afterend', errorDiv);
	}

	/**
	 * Limpia el mensaje y estilo de error de un elemento.
	 * @param {HTMLElement} element - Elemento del que quitar el error.
	 */
	static clearError(element) {
		element.classList.remove('border-red-500');

		// Restaurar clase de borde original
		if (element.dataset.originalBorderClass) {
			element.classList.add(element.dataset.originalBorderClass);
		} else {
			element.classList.add('border-gray-300');
		}

		const nextSibling = element.nextElementSibling;
		if (nextSibling && nextSibling.classList.contains('error-message')) {
			nextSibling.remove();
		}
	}

	/**
	 * Configura validación "requerido" en un input:
	 * - Al salir (blur) muestra error si está vacío.
	 * - Al escribir (input) borra el error.
	 * @param {HTMLElement} element - Input a validar.
	 * @param {string} message - Texto del mensaje de error.
	 */
	static setupRequiredField(element, message) {
		// Al perder foco, verificamos si está vacío
		element.addEventListener('blur', function () {
			if (!this.value.trim()) {
				Facturavia.showError(element, message);
			}
		});

		// Al escribir, quitamos el error
		element.addEventListener('input', function () {
			Facturavia.clearError(element);
		});
	}


	/**
	 * Reinicia un campo:
	 * - Elimina error y estilos.
	 * - Limpia su valor.
	 * @param {HTMLElement} element - Input a reiniciar.
	 */
	static resetField(element) {
		// Quita estilos y mensaje de error
		Facturavia.clearError(element);

		// Limpia el valor
		element.value = '';
	}

	/**
	 * Limpia todos los errores de un formulario.
	 * @param {HTMLElement} form
	 */
	static clearAllErrors(form) {
		form.querySelectorAll('input, textarea, select').forEach(function (el) {
			Facturavia.clearError(el);
		});
	}

	/**
	 * Inicializa o reinicia la validación automática.
	 * @param {string|HTMLElement} formSelector
	 */
	static initValidation(formSelector) {
		const form = typeof formSelector === 'string'
			? document.querySelector(formSelector)
			: formSelector;

		if (!form) return;

		// Store reference to event handlers for removal
		if (form._validationHandlers) {
			// Remove previous handlers
			form.removeEventListener('blur', form._validationHandlers.blur, true);
			form.removeEventListener('input', form._validationHandlers.input, true);
			form.removeEventListener('submit', form._validationHandlers.submit);
		}

		// Clear existing errors
		Facturavia.clearAllErrors(form);

		// Create handlers
		const handlers = {
			blur: function (e) {
				if (e.target.matches('input, textarea, select')) {
					Facturavia.validateField(e.target);
				}
			},
			input: function (e) {
				if (e.target.matches('input, textarea, select')) {
					Facturavia.clearError(e.target);
				}
			},
			submit: function (e) {
				if (!Facturavia.validateForm(form)) {
					e.preventDefault();
				}
			}
		};

		// Add event listeners
		form.addEventListener('blur', handlers.blur, true);
		form.addEventListener('input', handlers.input, true);
		form.addEventListener('submit', handlers.submit);

		// Store handlers for later removal
		form._validationHandlers = handlers;
		form._validationInitialized = true;
	}

	/**
	 * Valida un campo individual:
	 * @param {HTMLElement} el
	 * @returns {boolean}
	 */
	static validateField(el) {
		// 0) Saltar campos ocultos, deshabilitados o type="hidden"
		if (el.type === 'hidden' || el.disabled) return true;
		if (el.offsetParent === null && el.type !== 'checkbox' && el.type !== 'radio') return true;

		// 1) Validación específica para contraseña
		if (el.getAttribute('type') === 'password' && el.value.length < 8) {
			Facturavia.showError(el, 'La contraseña debe tener un mínimo de 8 caracteres.');
			return false;
		}

		// 2) Validación específica para email
		if (el.getAttribute('type') === 'email' && el.value.trim() !== '') {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!emailRegex.test(el.value.trim())) {
				Facturavia.showError(el, 'Introduce un email válido.');
				return false;
			}
		}

		// 3) Validación HTML5 nativa (required, pattern, type, minlength…)
		if (el.checkValidity && !el.checkValidity()) {
			let msg;
			if (el.validity.valueMissing) {
				msg = 'Este campo es obligatorio';
			} else {
				msg = el.dataset.errorMessage || el.validationMessage || 'Campo inválido';
			}
			Facturavia.showError(el, msg);
			return false;
		}

		// 4) Si todo OK, limpiar posibles errores previos
		Facturavia.clearError(el);
		return true;
	}

	/**
	 * Recorre y valida todos los campos del formulario:
	 * @param {HTMLElement} form
	 * @returns {boolean}
	 */
	static validateForm(form) {
		const formEl = typeof form === 'string' ? document.querySelector(form) : form;

		// 0) Comprobar initValidation
		if (!formEl._validationInitialized) {
			console.warn('⚠️ No se ha ejecutado initValidation en este formulario.');
			// Opcional: forzar inicialización en caliente
			Facturavia.initValidation(formEl);
		}

		// 1) Validar campos
		let isValid = true;
		let firstInvalid = null;
		formEl.querySelectorAll('input, textarea, select').forEach(function (el) {
			if (!Facturavia.validateField(el)) {
				isValid = false;
				if (!firstInvalid) firstInvalid = el;
			}
		});

		// 2) Scroll al primer campo con error
		if (firstInvalid) {
			firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
			firstInvalid.focus({ preventScroll: true });
		}

		return isValid;
	}

	/**
	 * Realiza una mutación GraphQL 'make'.
	 * @param {string} action - Acción a ejecutar.
	 * @param {object} variables - Variables para la acción. Si está vacío, se usará { user: 'me' }.
	 * @param {function} onsuccess - Callback de éxito.
	 * @returns {object} - Resultado con data y errors.
	 */
	static async make(action, variables = {}, onsuccess = null, onerror = null, options = {}) {

		if (Object.keys(variables).length === 0) {
			variables = { user: 'me' };
		}


		const query = `
			mutation make($action: String!, $variables: String!) {
				make(action: $action, variables: $variables) {
					errors {
						field
						message
					}
					data
				}
			}
		`;

		const body = JSON.stringify({
			query: query,
			variables: {
				action: action,
				variables: JSON.stringify(variables),
			},
		});

		// Leer la cookie 'token'
		var token = document.cookie
			.split('; ')
			.find(row => row.startsWith('token='))
			?.split('=')[1];

		var sid = document.cookie
			.split('; ')
			.find(row => row.startsWith('sid='))
			?.split('=')[1];

		if (sid)
			token = sid;

		var sidm = document.cookie
			.split('; ')
			.find(row => row.startsWith('sidm='))
			?.split('=')[1];

		if (sidm)
			token = sidm;

		// Construir los encabezados
		const headers = {
			'Content-Type': 'application/json',
		};

		if (token) {
			headers['x-api-key'] = token; // Agregar el token si existe
		}

		// CSRF protection para mutations
		const csrfToken = Facturavia.getCsrfToken();
		if (csrfToken) {
			headers['X-CSRF-Token'] = csrfToken;
		}

		try {
			const response = await fetch('/graphql', {
				method: 'POST',
				headers: headers,
				body: body,
				signal: options.signal,
			});

			const result = await response.json();


			if (result.errors) {
				Facturavia.showNotification({
					message: result.errors[0].message,
					type: 'error'
				});
				if (typeof onerror === 'function') {
					onerror(result.errors);
				}
				return { errors: result.errors, data: null };
			}

			const data = JSON.parse(result.data.make.data);
			const errors = result.data.make.errors || [];

			// Ejecutar callback si está definido y no hay errores

			if (errors.length === 0 && typeof onsuccess === 'function') {
				onsuccess(data);
			} else if (errors.length > 0) {
				if (typeof onerror === 'function') {
					onerror(errors);
				} else {
					// Sin callback de error: mostrar notificación para errores genéricos (field null)
					errors.forEach(function (err) {
						if (!err.field) {
							Facturavia.showNotification({
								message: err.message || 'Error',
								type: 'error'
							});
						}
					});
				}
			}

			return { data, errors };
		} catch (error) {
			if (error.name === 'AbortError') return { errors: [], data: null };
			var catchErrors = [{ field: null, message: error.message }];
			if (typeof onerror === 'function') {
				onerror(catchErrors);
			} else {
				Facturavia.showNotification({
					message: error.message,
					type: 'error'
				});
			}
			return { errors: catchErrors, data: null };
		}
	}

	/**
	 * Realiza una mutación GraphQL 'make' con notificación de error integrada.
	 * @param {string} action - Acción a ejecutar.
	 * @param {object} variables - Variables para la acción. Si está vacío, se usará { user: 'me' }.
	 * @param {function} onsuccess - Callback de éxito.
	 * @param {function} onError - Callback de error.
	 * @returns {object} - Resultado con data y errors.
	 */
	static async makeAction(action, variables = {}, onsuccess = null, onError = null, options = {}) {

		if (Object.keys(variables).length === 0) {
			variables = { user: 'me' };
		}

		const query = `
			mutation make($action: String!, $variables: String!) {
				make(action: $action, variables: $variables) {
					errors {
						field
						message
					}
					data
				}
			}
		`;

		const body = JSON.stringify({
			query: query,
			variables: {
				action: action,
				variables: JSON.stringify(variables),
			},
		});

		// **Leer la cookie 'token'**
		var token = document.cookie
			.split('; ')
			.find(row => row.startsWith('token='))
			?.split('=')[1];

		var sid = document.cookie
			.split('; ')
			.find(row => row.startsWith('sid='))
			?.split('=')[1];

		if (sid)
			token = sid;

		var sidm = document.cookie
			.split('; ')
			.find(row => row.startsWith('sidm='))
			?.split('=')[1];

		if (sidm)
			token = sidm;

		// **Construir los encabezados**
		const headers = {
			'Content-Type': 'application/json',
		};

		if (token) {
			headers['x-api-key'] = token; // **Agregar el token** si existe
		}

		// CSRF protection para mutations
		const csrfToken = Facturavia.getCsrfToken();
		if (csrfToken) {
			headers['X-CSRF-Token'] = csrfToken;
		}

		try {
			const response = await fetch('/graphql', {
				method: 'POST',
				headers: headers,
				body: body,
				signal: options.signal,
			});

			const result = await response.json();

			// **Si hay error en la respuesta, se muestra la notificación**
			if (result.errors) {
				if (onError) {
					onError(result.errors);
				}

				Facturavia.showNotification({
					message: result.errors[0].message, // Puedes concatenar mensajes si hay más de uno
					type: 'error'
				});
				return { errors: result.errors, data: null };
			}

			const data = JSON.parse(result.data.make.data);
			const errors = result.data.make.errors || [];
			var _unhandled = [];

			// **Mostrar errores en los inputs correspondientes**
			if (errors.length > 0) {
				errors.forEach(error => {
					if (error.field) {
						// Buscar el input por nombre
						const $input = document.querySelector(`[name="${error.field}"]`);
						if ($input) {
							Facturavia.showError($input, error.message);
						} else {
							_unhandled.push(error);
						}
					} else {
						_unhandled.push(error);
					}
				});
				if (_unhandled.length > 0) {
					if (onError) {
						onError(_unhandled);
					} else {
						Facturavia.showNotification({
							message: _unhandled[0].message,
							type: 'error'
						});
					}
				}
			}

			// **Ejecutar callback en caso de éxito**
			if (onsuccess && errors.length === 0) {
				onsuccess(data);
			}

			return { data, errors };
		} catch (error) {
			if (error.name === 'AbortError') return { errors: [], data: null };
			// **En caso de excepción, también se muestra la notificación de error**
			Facturavia.showNotification({
				message: error.message,
				type: 'error'
			});
			return { errors: [{ field: null, message: error.message }], data: null };
		}
	}


	static showNotification({ title = "", message = "", type = "success", duration = 5000 }) {
		// Asegurarse de que exista un contenedor de **notificaciones**
		var notificationContainer = document.querySelector("#notification-container");
		if (!notificationContainer) {
			notificationContainer = document.createElement("div");
			notificationContainer.id = "notification-container";
			notificationContainer.setAttribute("data-turbo-permanent", "");
			notificationContainer.className = "fixed bottom-[20px] right-[20px] flex flex-col-reverse gap-4 z-10";
			document.body.appendChild(notificationContainer);
		}

		// Definir color de borde según el tipo de notificación
		var borderColor = type === "success" ? "#1EA779" : "#ff0601";

		// Crear el contenedor de la **notificación**
		var notification = document.createElement("div");
		notification.className = "notification px-4 py-3 rounded-lg shadow-2 bg-white dark:bg-gray-900 dark:text-gray-200 transform";
		notification.style.border = `2px solid ${borderColor}`; // Cambia el color del borde dinámicamente

		// Seleccionar el **icono** según el **tipo** de notificación
		var iconHTML = "";
		if (type === "success") {
			iconHTML = `
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5 14L8.23309 16.4248C8.66178 16.7463 9.26772 16.6728 9.60705 16.2581L18 6" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
				</svg>
			`;
		} else if (type === "error") {
			iconHTML = `
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M6 6L18 18" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
					<path d="M6 18L18 6" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
				</svg>
			`;
		}

		// Crear el contenido de la **notificación**
		notification.innerHTML = `
			<div class="flex items-center justify-between gap-4 close-notification">
				<div class="flex flex-grow items-center gap-5">
					<div class="flex h-5 w-5 items-center justify-center rounded-full" style="background-color: ${borderColor}">
						${iconHTML}
					</div>
					<div>
						<p class="text-base font-medium mr-8">${message}</p>
					</div>
				</div>
				<div>
					<button class="hover:opacity-80  flex items-center">
						<svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M0.854423 0.85186C1.2124 0.493879 1.79281 0.493879 2.15079 0.85186L7.0026 5.70368L11.8544 0.85186C12.2124 0.493879 12.7928 0.493879 13.1508 0.85186C13.5088 1.20984 13.5088 1.79024 13.1508 2.14822L8.29897 7.00004L13.1508 11.8519C13.5088 12.2098 13.5088 12.7902 13.1508 13.1482C12.7928 13.5062 12.2124 13.5062 11.8544 13.1482L7.0026 8.2964L2.15079 13.1482C1.79281 13.5062 1.2124 13.5062 0.854423 13.1482C0.496442 12.7902 0.496442 12.2098 0.854423 11.8519L5.70624 7.00004L0.854423 2.14822C0.496442 1.79024 0.496442 1.20984 0.854423 0.85186Z" fill="currentColor"></path>
						</svg>
					</button>
				</div>
			</div>
		`;

		// Agregar al contenedor principal
		notificationContainer.appendChild(notification);

		// Mostrar la **notificación** con animación
		nativeSetTimeout(function () {
			notification.classList.add("show");
		}, 10);

		// Cerrar la **notificación** manualmente
		notification.querySelector(".close-notification").addEventListener("click", function () {
			notification.classList.add("hide");
			nativeSetTimeout(function () { notification.remove(); }, 300);
		});

		// Eliminar automáticamente después de la duración especificada
		if (duration > 0) {
			nativeSetTimeout(function () {
				notification.classList.add("hide");
				nativeSetTimeout(function () { notification.remove(); }, 300);
			}, duration);
		}
	}

	/**
	 * Muestra un modal de confirmación reutilizable
	 *
	 * @param {object} options - Opciones de configuración
	 * @param {string} options.title - Título del modal (default: "Confirmar acción")
	 * @param {string} options.message - Mensaje del modal
	 * @param {string} options.confirmText - Texto del botón confirmar (default: "Confirmar")
	 * @param {string} options.cancelText - Texto del botón cancelar (default: "Cancelar")
	 * @param {string} options.confirmClass - Clases CSS del botón confirmar (default: "bg-black hover:bg-gray-800")
	 * @param {function} options.onConfirm - Callback al confirmar
	 * @param {function} options.onCancel - Callback al cancelar (opcional)
	 */
	static showConfirm({
		title = "Confirmar acción",
		message = "¿Está seguro de que desea continuar?",
		confirmText = "Confirmar",
		cancelText = "Cancelar",
		confirmClass = "bg-black hover:bg-gray-800",
		onConfirm = () => { },
		onCancel = () => { }
	}) {
		const modal = document.getElementById('confirmModal');
		const modalBack = document.getElementById('confirmModalBack');
		const modalTitle = document.getElementById('confirmModalTitle');
		const modalMessage = document.getElementById('confirmModalMessage');
		const btnConfirm = document.getElementById('confirmModalConfirm');
		const btnCancel = document.getElementById('confirmModalCancel');

		if (!modal || !btnConfirm || !btnCancel) {
			console.warn('Modal de confirmación no encontrado en el DOM');
			// Fallback a confirm nativo
			if (window.confirm(message)) {
				onConfirm();
			} else {
				onCancel();
			}
			return;
		}

		// Configurar contenido
		if (modalTitle) modalTitle.textContent = title;
		if (modalMessage) modalMessage.textContent = message;
		if (btnConfirm) btnConfirm.textContent = confirmText;
		if (btnCancel) btnCancel.textContent = cancelText;

		// Actualizar clases del botón confirmar
		if (btnConfirm) {
			btnConfirm.className = `px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${confirmClass}`;
		}

		// Función para cerrar el modal
		const closeModal = () => {
			modal.classList.add('hidden');
			document.body.classList.remove('overflow-hidden');
			// Limpiar event listeners
			btnConfirm.replaceWith(btnConfirm.cloneNode(true));
			btnCancel.replaceWith(btnCancel.cloneNode(true));
			if (modalBack) modalBack.replaceWith(modalBack.cloneNode(true));
		};

		// Event listeners (re-obtener referencias después de clonar)
		const newBtnConfirm = document.getElementById('confirmModalConfirm');
		const newBtnCancel = document.getElementById('confirmModalCancel');
		const newModalBack = document.getElementById('confirmModalBack');

		if (newBtnConfirm) {
			newBtnConfirm.addEventListener('click', () => {
				closeModal();
				onConfirm();
			});
		}

		if (newBtnCancel) {
			newBtnCancel.addEventListener('click', () => {
				closeModal();
				onCancel();
			});
		}

		if (newModalBack) {
			newModalBack.addEventListener('click', () => {
				closeModal();
				onCancel();
			});
		}

		// Cerrar con ESC
		const handleEsc = (e) => {
			if (e.key === 'Escape') {
				closeModal();
				onCancel();
				document.removeEventListener('keydown', handleEsc);
			}
		};
		document.addEventListener('keydown', handleEsc);

		// Mostrar modal
		modal.classList.remove('hidden');
		document.body.classList.add('overflow-hidden');
	}


	/**
	 * Ejecuta una consulta GraphQL para obtener una lista de objetos.
	 * Útil cuando se necesita filtrar por criterios como state, search, etc.
	 *
	 * @param {string} action - El nombre de la query (ej: 'invoices', 'products').
	 * @param {string} node - Los campos a solicitar del nodo (ej: 'id name total'). Por defecto 'id'.
	 * @param {object} variables - Variables para la query (limit, offset, search, filter, etc).
	 * @param {function} onSuccess - Callback si tiene éxito.
	 * @param {function} onError - Callback si falla.
	 */
	static async executeQueryGraphQL(action, node = 'id', variables = {}, onSuccess = () => { }, onError = () => { }, options = {}) {
		let filter = '{}';

		if (variables.filter && Object.keys(variables.filter).length > 0) {
			const filterParts = Object.entries(variables.filter).map(([key, value]) => {
				if (Array.isArray(value)) {
					// Convertir array a formato GraphQL ["1","2","3"]
					return `${key}: [${value.map(v => `"${v}"`).join(', ')}]`;
				} else {
					// String normal o número
					return `${key}: "${String(value).replace(/"/g, '\\"')}"`;
				}
			});
			filter = `{ ${filterParts.join(', ')} }`;
		}

		const query = `
			query ($limit: Int!, $after: String!, $before: String!, $offset: Int!, $search: String!) {
				${action}(limit: $limit, after: $after, before: $before, offset: $offset, search: $search, filter: ${filter}) {
					edges {
						node {
							${node}
						}
					}
					pageInfo {
						startCursor
						endCursor
						hasNextPage
						hasPreviousPage
					}
					totalCount
				}
			}
		`;

		if (!variables.offset) {
			variables.offset = 0;
		}

		const variableValues = {
			limit: variables.limit || 10, // Por defecto 10 eventos
			after: variables.after || "",
			before: variables.before || "",
			offset: parseInt(variables.offset, 10) || 0,
			search: variables.search || '',
			filter: variables.filter || {}
		};

		try {
			// Realizar la petición HTTP al endpoint GraphQL
			const response = await fetch('/graphql', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					query,
					variables: variableValues
				}),
				signal: options.signal,
			});

			if (!response.ok) {
				throw new Error(`Error en la petición: ${response.statusText}`);
			}

			const result = await response.json();

			// Verificar si hay errores en la respuesta de GraphQL
			if (result.errors) {
				throw new Error(
					result.errors.map(error => error.message).join('\n')
				);
			}

			// Llamar a la función onSuccess si la petición fue exitosa
			onSuccess(result.data);
			return result.data;
		} catch (error) {
			if (error.name === 'AbortError') return { errors: [], data: null };
			// Llamar a la función onError en caso de un error
			onError(error);
			return {
				errors: [
					{
						message: error.message
					}
				]
			};
		}
	}

	/**
	 * Ejecuta una consulta GraphQL para obtener un único objeto por ID.
	 * 
	 * @param {string} action - El nombre de la query individual (ej: 'invoice', 'product').
	 * @param {string} node - Los campos a solicitar (ej: 'id invoice_state'). Por defecto 'id'.
	 * @param {object} variables - Debe contener el 'id' del objeto.
	 * @param {function} onSuccess - Callback éxito.
	 * @param {function} onError - Callback error.
	 */
	static async executeSingleQueryGraphQL(action, node = 'id', variables = {}, onSuccess = () => { }, onError = () => { }, options = {}) {
		const { id } = variables;
		if (!id) {
			const error = new Error('Se requiere un **id** para la consulta **GraphQL**.');
			onError(error);
			return { errors: [{ message: error.message }] };
		}

		const query = `
		  query ($id: String!) {
			${action}(id: $id) {
			  ${node}
			}
		  }
		`;

		const variableValues = {
			id: String(id)
		};

		try {
			const response = await fetch('/graphql', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					query,
					variables: variableValues
				}),
				signal: options.signal,
			});

			if (!response.ok) {
				throw new Error(`Error en la petición: ${response.statusText}`);
			}

			const result = await response.json();

			if (result.errors) {
				throw new Error(result.errors.map(e => e.message).join('\n'));
			}

			onSuccess(result.data);
			return result.data;
		} catch (error) {
			if (error.name === 'AbortError') return { errors: [], data: null };
			onError(error);
			return { errors: [{ message: error.message }] };
		}
	}

	// Función para guardar un valor en una variable global con un identificador
	static guardarVariableGlobal(clave, valor) {
		if (!window.variablesGlobales) {
			window.variablesGlobales = {}; // Inicializamos un objeto en window si no existe
		}
		window.variablesGlobales[clave] = valor;
	}

	// Función para recuperar un valor previamente guardado
	static obtenerVariableGlobal(clave) {
		if (window.variablesGlobales && window.variablesGlobales[clave]) {
			return window.variablesGlobales[clave];
		}
		return null;
	}

	// Función para eliminar una variable global por su clave
	static eliminarVariableGlobal(clave) {
		if (window.variablesGlobales && window.variablesGlobales[clave]) {
			delete window.variablesGlobales[clave];
		} else {
		}
	}


	static currentMenu = null;

	static toggleMenu(menuId) {
		var menu = document.getElementById(menuId);
		var overlay = document.getElementById('dynamicOverlay');

		// Crear el overlay si no existe
		if (!overlay) {
			overlay = document.createElement('div');
			overlay.id = 'dynamicOverlay';
			overlay.className = 'hidden z-10 bg-[#000] opacity-0 fixed top-0 left-0 w-full h-full transition-opacity duration-300';
			overlay.style.display = 'none';
			overlay.onclick = function () {
				Facturavia.closeToggleMenu();
			};
			document.body.appendChild(overlay);
		}

		// Mostrar u ocultar el menú
		if (menu.style.display === 'none' || !menu.style.display) {
			if (Facturavia.currentMenu && Facturavia.currentMenu !== menuId) {
				Facturavia.closeToggleMenu(); // Cierra cualquier menú abierto
			}

			Facturavia.currentMenu = menuId;
			overlay.style.display = 'block';
			menu.style.display = 'block';

			// Añadir efectos de transición
			setTimeout(function () {
				menu.style.transform = 'translateY(0)';
				overlay.style.opacity = '0.5';
			}, 10);
		} else {
			Facturavia.closeToggleMenu(); // Cierra el menú actual
		}
	}

	static closeToggleMenu() {
		if (!Facturavia.currentMenu) return; // Si no hay un menú abierto, no hace nada

		var menu = document.getElementById(Facturavia.currentMenu);
		var overlay = document.getElementById('dynamicOverlay');

		if (menu) {
			menu.style.transform = 'translateY(100%)';
		}

		if (overlay) {
			overlay.style.opacity = '0';
		}

		// Espera a que termine la transición antes de ocultar
		setTimeout(function () {
			if (menu) menu.style.display = 'none';
			if (overlay) overlay.style.display = 'none';
			Facturavia.currentMenu = null; // Resetea el menú activo
		}, 300);
	}

	/**
	 * Close the slider panel that contains the given element.
	 * Uses window.closeSlider_X if available, otherwise closes via CSS directly.
	 */
	static closeSliderPanel(el) {
		var panel = el.closest('[id^="slidingPanel"], [id^="slidingFilter"]');
		if (panel && window['closeSlider_' + panel.id]) {
			window['closeSlider_' + panel.id]();
			return;
		}
		// Fallback: close by CSS (works even if setupSlider hasn't run yet)
		if (panel) {
			panel.classList.remove('translate-x-0');
			panel.classList.add('translate-x-full');
			var bg = document.getElementById(panel.id + '_background');
			if (bg) {
				bg.classList.add('bg-[#0000]', 'backdrop-blur-0');
				bg.classList.remove('bg-[#0006]', 'backdrop-blur-[4px]');
				setTimeout(function() { bg.classList.add('hidden'); }, 500);
			}
			return;
		}
		// Last resort: click the closeSlider button
		var closeBtn = document.getElementById('closeSlider');
		if (closeBtn) closeBtn.click();
	}

	static setupSlider(sliderId, buttonId, closeButtonId) {
		var slidingPanel = document.getElementById(sliderId);
		if (!slidingPanel) return;

		// Prevent double-init (preload + page module both call this)
		var slideButton = document.getElementById(buttonId);
		if (slideButton && slideButton._sliderInitialized) return;
		if (slideButton) slideButton._sliderInitialized = true;

		var backgroundId = sliderId + "_background";
		var slidingBackground = document.getElementById(backgroundId);

		// Si el background no existe, crearlo
		if (!slidingBackground) {
			slidingBackground = document.createElement("div");
			slidingBackground.id = backgroundId;
			slidingBackground.classList.add("z-40", "fixed", "inset-0", "hidden", "bg-[#0000]", "backdrop-blur-0", "transition-all", "duration-500");
			document.body.appendChild(slidingBackground);
		} else {
			// Reset to hidden state (may be stale from interrupted navigation)
			slidingBackground.classList.add("hidden", "bg-[#0000]", "backdrop-blur-0");
			slidingBackground.classList.remove("bg-[#0006]", "backdrop-blur-[4px]");
		}

		var closeButton = document.getElementById(closeButtonId);

		// Función para abrir el deslizador
		var openSlider = () => {
			slidingPanel.classList.remove("translate-x-full");
			slidingPanel.classList.add("translate-x-0");

			slidingBackground.classList.remove("hidden");
			setTimeout(() => {
				slidingBackground.classList.add("bg-[#0006]", "backdrop-blur-[4px]");
				slidingBackground.classList.remove("bg-[#0000]", "backdrop-blur-0");
			}, 10);
		};

		// Función para cerrar el deslizador
		var closeSlider = () => {
			slidingPanel.classList.remove("translate-x-0");
			slidingPanel.classList.add("translate-x-full");

			slidingBackground.classList.add("bg-[#0000]", "backdrop-blur-0");
			slidingBackground.classList.remove("bg-[#0006]", "backdrop-blur-[4px]");

			setTimeout(() => {
				slidingBackground.classList.add("hidden");
			}, 500);
		};

		// Evento para cerrar el deslizador al hacer clic en el fondo
		slidingBackground.addEventListener("click", closeSlider);

		// Evento para cerrar el deslizador al hacer clic en el botón de cierre
		if (closeButton) {
			closeButton.addEventListener("click", closeSlider);
		}

		// Evento para abrir el deslizador al hacer clic en el botón
		if (slideButton) {
			slideButton.addEventListener("click", openSlider);
		}

		// Exponer las funciones si se necesita acceso global
		window[`openSlider_${sliderId}`] = openSlider;
		window[`closeSlider_${sliderId}`] = closeSlider;
	}

	static setupSliderModal(sliderId, buttonClass, closeButtonId) {
		var slidingPanel = document.getElementById(sliderId);
		if (!slidingPanel) return;

		var backgroundId = sliderId + "_background";
		var slidingBackground = document.getElementById(backgroundId);

		// Si el background no existe, crearlo
		if (!slidingBackground) {
			slidingBackground = document.createElement("div");
			slidingBackground.id = backgroundId;
			slidingBackground.classList.add("z-40", "fixed", "inset-0", "hidden", "bg-[#0000]", "backdrop-blur-0", "transition-all", "duration-500");
			document.body.appendChild(slidingBackground);
		} else {
			// Reset to hidden state (may be stale from interrupted navigation)
			slidingBackground.classList.add("hidden", "bg-[#0000]", "backdrop-blur-0");
			slidingBackground.classList.remove("bg-[#0006]", "backdrop-blur-[4px]");
		}

		// Seleccionar los botones por **clase**
		var slideButtons = document.querySelectorAll("." + buttonClass);
		var closeButton = document.getElementById(closeButtonId);

		// Función para abrir el **slider**
		var openSlider = function () {
			slidingPanel.classList.remove("translate-x-full");
			slidingPanel.classList.add("translate-x-0");

			slidingBackground.classList.remove("hidden");
			setTimeout(function () {
				slidingBackground.classList.add("bg-[#0006]", "backdrop-blur-[4px]");
				slidingBackground.classList.remove("bg-[#0000]", "backdrop-blur-0");
			}, 10);
		};

		// Función para cerrar el **slider**
		var closeSlider = function () {
			slidingPanel.classList.remove("translate-x-0");
			slidingPanel.classList.add("translate-x-full");

			slidingBackground.classList.add("bg-[#0000]", "backdrop-blur-0");
			slidingBackground.classList.remove("bg-[#0006]", "backdrop-blur-[4px]");

			setTimeout(function () {
				slidingBackground.classList.add("hidden");
			}, 500);
		};

		// Evento para cerrar el **slider** al hacer clic en el fondo
		slidingBackground.addEventListener("click", closeSlider);

		// Evento para cerrar el **slider** al hacer clic en el botón de cierre
		if (closeButton) {
			closeButton.addEventListener("click", closeSlider);
		}

		// Evento para abrir el **slider** al hacer clic en los botones con la **clase**
		if (slideButtons.length > 0) {
			for (var i = 0; i < slideButtons.length; i++) {
				slideButtons[i].addEventListener("click", function (e) {
					// Recoger datos extra del botón mediante **data-attributes**
					var name = this.getAttribute("data-name") || "prueba";
					var extraId = this.getAttribute("data-id") || "test";

					// Construir la URL con los parámetros
					var url = "/html/" + encodeURIComponent(name) + "?id=" + encodeURIComponent(extraId);

					// Realizar la petición **ajax**
					var xhr = new XMLHttpRequest();
					xhr.open("GET", url, true);
					xhr.onreadystatechange = function () {
						if (xhr.readyState === 4) {
							if (xhr.status === 200) {
								try {
									var jsonResponse = JSON.parse(xhr.responseText);
									slidingPanel.innerHTML = DOMPurify.sanitize(jsonResponse.content, { ADD_TAGS: ['turbo-frame'], ADD_ATTR: ['data-page', 'data-id', 'data-name', 'data-turbo-frame'] });
									openSlider();
								} catch (error) {
									console.error("Error parseando la respuesta JSON", error);
								}
							} else {
								console.error("Error en la petición **ajax**");
							}
						}
					};
					xhr.send();
				});
			}
		}

		// Exponer las funciones si se necesita acceso global
		window["openSlider_" + sliderId] = openSlider;
		window["closeSlider_" + sliderId] = closeSlider;
	}

	static enableButton(btn) {
		// Support both DOM elements and string selectors
		if (typeof btn === 'string') {
			btn = document.querySelector(btn);
		}
		if (!btn) return;
		// Activar el botón restaurando su contenido original
		const originalText = btn._originalText;
		btn.classList.remove('opacity-50', 'pointer-events-none');
		if (originalText) {
			btn.innerHTML = originalText;
			delete btn._originalText;
		}
	}

	static disableButton(btn) {
		// Support both DOM elements and string selectors
		if (typeof btn === 'string') {
			btn = document.querySelector(btn);
		}
		if (!btn) return;
		// Almacenar el contenido original para restaurarlo después
		const originalText = btn.innerHTML;
		btn._originalText = originalText;
		// Desactivar el botón aplicando clases y mostrar un spinner de cargando
		btn.classList.add('opacity-50', 'pointer-events-none');
		btn.innerHTML = '<svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>';
	}

	static appPostMessage(data) {
		if (window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(JSON.stringify(data));
		}
	}

	static isApp() {
		if (window.ReactNativeWebView)
			return true;
		else
			return false;
	}


	static updateUrlParameter(param, value) {
		const url = new URL(window.location.href);
		const params = url.searchParams;

		const valorActual = params.get(param);
		const reverseActual = params.get('reverse') === '1';

		if (valorActual === value) {
			if (reverseActual) {
				params.delete('reverse'); // Ya está reverse, lo quitamos (efecto toggle)
			} else {
				params.set('reverse', '1'); // No estaba, lo activamos
			}
		} else {
			params.set(param, value);     // Cambia el valor
			params.delete('reverse');     // Reiniciamos reverse
		}

		params.set(param, value);
		Facturavia.link(url.toString());
	}

	static tagify(input, parms) {
		// Destroy stale instance (Turbo cache / re-navigation)
		if (input.tagify) {
			try { input.tagify.destroy(); } catch(e) {}
			input.tagify = null;
		}
		// Remove orphaned .tagify wrapper that preload() may have left
		var sibling = input.nextElementSibling;
		if (sibling && sibling.classList.contains('tagify')) sibling.remove();
		// Restore original HTML value and clear inline styles from old Tagify
		input.removeAttribute('style');
		input.value = input.getAttribute('value') || '';

		var tagify = new Tagify(input, parms);
		input.tagify = tagify;
		return tagify;
	}

	// Tom Select - Vanilla JS select widget
	static loadTomSelect(selector, options = {}) {
		// Obtener elemento
		let el;
		if (typeof selector === 'string') {
			el = document.querySelector(selector);
		} else if (selector instanceof HTMLElement) {
			el = selector;
		} else {
			console.warn('loadTomSelect: selector inválido', selector);
			return null;
		}

		if (!el) {
			console.warn('loadTomSelect: elemento no encontrado', selector);
			return null;
		}

		// Si ya tiene Tom Select inicializado, destruirlo primero
		if (el.tomselect) {
			el.tomselect.destroy();
		}

		// Configuración por defecto con plugin dropdown_input
		const defaultOptions = {
			plugins: ['dropdown_input'],
			create: false,
			placeholder: options.placeholder || 'Seleccione una opción',
			allowEmptyOption: true,
			controlInput: null, // dropdown_input maneja el input
			render: {
				no_results: function (data, escape) {
					return '<div class="no-results">Sin resultados</div>';
				}
			}
		};

		// Merge de opciones
		const finalOptions = { ...defaultOptions, ...options };

		try {
			// Crear instancia
			const tomSelect = new TomSelect(el, finalOptions);
			return tomSelect;
		} catch (error) {
			console.error('loadTomSelect: Error al inicializar', selector, error);
			return null;
		}
	}

	// Destruir instancia de Tom Select
	static destroyTomSelect(selector) {
		let el;
		if (typeof selector === 'string') {
			el = document.querySelector(selector);
		} else if (selector instanceof HTMLElement) {
			el = selector;
		}

		if (el && el.tomselect) {
			el.tomselect.destroy();
		}
	}



	static parseFecha(fecha) {
		if (!fecha) return "";

		// Lista amplia de formatos posibles
		var formatos = [
			// guiones
			"YYYY-MM-DD", "DD-MM-YYYY", "MM-DD-YYYY",
			// barras
			"YYYY/MM/DD", "DD/MM/YYYY", "MM/DD/YYYY",
			// puntos
			"YYYY.MM.DD", "DD.MM.YYYY", "MM.DD.YYYY",
			// solo año y mes
			"YYYY-MM", "YYYY/MM", "YYYY.MM",
			// día mes nombre
			"DD MMM YYYY", "MMM DD, YYYY", "MMMM DD, YYYY",
			"DD de MMMM de YYYY", // español
			// solo año
			"YYYY"
		];

		var m = moment(fecha, formatos, true); // validación estricta
		if (m.isValid()) {
			return m.format("YYYY-MM-DD"); // salida uniforme
		} else {
			// último recurso: intentar con el Date nativo
			var d = new Date(fecha);
			if (!isNaN(d.getTime())) {
				return moment(d).format("YYYY-MM-DD");
			}
			return fecha; // si no se reconoce, devolver original
		}
	}

	/**
	 * Inicializa la detección de cambio de cuenta entre pestañas.
	 * Cuando el usuario cambia de cuenta en otra pestaña, muestra un modal.
	 * @param {string} accountId - ID de la cuenta actual de la página
	 */
	static initAccountChangeDetection(accountId) {
		if (!accountId) return;

		const STORAGE_KEY = 'fv_current_account';
		const pageAccountId = accountId;

		// Guardar el account actual en localStorage
		localStorage.setItem(STORAGE_KEY, accountId);

		// Escuchar cambios en localStorage desde otras pestañas
		window.addEventListener('storage', function (event) {
			if (event.key !== STORAGE_KEY) return;

			const newAccountId = event.newValue;

			// Si el account cambió y es diferente al de esta página
			if (newAccountId && newAccountId !== pageAccountId) {
				Facturavia.showAccountChangedModal();
			}
		});
	}

	/**
	 * Muestra el modal de cambio de cuenta con botón para refrescar.
	 */
	static showAccountChangedModal() {
		// Evitar mostrar múltiples modales
		if (document.getElementById('account-changed-modal')) return;

		const modalHtml = `
			<div id="account-changed-modal" class="fixed inset-0 z-[9999] flex items-center justify-center">
				<div class="absolute inset-0 bg-black bg-opacity-50"></div>
				<div class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
					<div class="flex items-center mb-4">
						<div class="flex-shrink-0 w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center mr-4">
							<svg class="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
							</svg>
						</div>
						<div>
							<h3 class="text-lg font-semibold text-gray-900">Cuenta cambiada</h3>
							<p class="text-sm text-gray-600 mt-1">Se ha cambiado de cuenta en otra pestaña. Para continuar trabajando, es necesario actualizar esta página.</p>
						</div>
					</div>
					<div class="flex justify-end">
						<button onclick="window.location.reload()" class="px-4 py-2 bg-black text-white rounded-lg hover:bg-opacity-80 transition-colors">
							Actualizar página
						</button>
					</div>
				</div>
			</div>
		`;

		document.body.insertAdjacentHTML('beforeend', modalHtml);
		document.body.classList.add('overflow-hidden');
	}





}

// Navigation uses @hotwired/turbo (initialized in init.js)
window.Facturavia = Facturavia;

// Initialize
initTracking();
initApp();
initHeader();

// Initialize automatic page module loading
// Este sistema carga automáticamente los módulos JS según el atributo data-page del body
// Para añadir un nuevo módulo:
//   1. Crear el archivo en _dev/assets/pages/{nombre-pagina}.js
//   2. Exportar una función init{NombrePagina}()
//   3. Registrar el módulo en pageLoader.js
initPageLoader();

// Document-level delegation for btnEnviarTodos.
// Registered once on document — works regardless of DOM timing or Turbo frame swaps.
document.addEventListener('click', function(e) {
	var btn = e.target.closest('#btnEnviarTodos');
	if (!btn) return;
	var groupId = String((document.getElementById('assignGroupId') || {}).value || '').trim();
	if (!groupId) { alert('Grupo inválido.'); return; }
	var rowsBody = document.getElementById('rowsBody');
	if (!rowsBody) return;
	var assignedFileIds = [];
	rowsBody.querySelectorAll('tr[data-assigned="1"]').forEach(function(tr) {
		var id = String(tr.getAttribute('data-file-id') || '').trim();
		if (id) assignedFileIds.push(id);
	});
	if (!assignedFileIds.length) {
		alert('No hay documentos asignados para enviar. Por favor, asigna documentos primero.');
		return;
	}
	Facturavia.showConfirm({
		title: 'Enviar notificaciones',
		message: '¿Enviar notificaciones por email a todos los usuarios asignados (' + assignedFileIds.length + ' documento(s))?',
		confirmText: 'Enviar',
		cancelText: 'Cancelar',
		confirmClass: 'bg-black hover:bg-gray-800',
		onConfirm: function() {
			btn.disabled = true;
			btn.textContent = 'Enviando...';
			Facturavia.make('documentGroupSendNotifications', {
				document_group_id: String(groupId),
				file_ids: assignedFileIds.map(String)
			}, function(res) {
				btn.disabled = false;
				btn.textContent = 'Enviar todos';
				if (res && res.errors && res.errors.length) {
					var errorMsg = res.errors.map(function(e) { return e.message; }).join('\n');
					alert('Error: ' + errorMsg);
					return;
				}
				var data = (res && res.data) || {};
				var sentCount = data.sent || 0;
				var errorsArray = data.errors || [];
				var message = sentCount + ' notificación(es) enviada(s) exitosamente.';
				if (errorsArray.length > 0) {
					message += '\n\nAlgunos errores:\n' + errorsArray.join('\n');
				}
				Facturavia.showNotification({ message: message });
				setTimeout(function() { window.location.reload(); }, 1500);
			});
		}
	});
});

// ── AutoFirma: interceptar clics en enlaces de descarga FacturaE ──
// Solo firma si la preferencia SIGN_FACTURAE está activada (data-sign-facturae="1" en <body>)
document.addEventListener('click', function(e) {
	var link = e.target.closest('a[href*="descargar-einvoice"]');
	if (!link) return;

	// Si la preferencia de firma no está activada, dejar la descarga normal
	if (document.body.getAttribute('data-sign-facturae') !== '1') return;

	e.preventDefault();
	e.stopPropagation();

	// Extraer el ID de la factura de la URL
	var href = link.getAttribute('href') || '';
	var match = href.match(/[?&]id=([^&]+)/);
	if (!match) return;
	var invoiceId = match[1];

	// Mostrar indicador de estado
	var statusEl = document.createElement('div');
	statusEl.id = 'afirma-status';
	statusEl.className = 'fixed bottom-4 right-4 z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-4 flex items-center gap-3 max-w-sm';
	statusEl.innerHTML = '<svg class="animate-spin h-5 w-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg><span class="text-sm text-gray-700">Preparando firma electrónica...</span>';
	document.body.appendChild(statusEl);

	function updateStatus(msg) {
		var span = statusEl.querySelector('span');
		if (span) span.textContent = msg;
	}

	function removeStatus() {
		if (statusEl.parentNode) statusEl.parentNode.removeChild(statusEl);
	}

	import(/* webpackChunkName: "autofirma" */ './autofirma-client.js').then(function(mod) {
		mod.signWithAutoFirma(invoiceId, { onStatus: updateStatus })
			.then(function() {
				removeStatus();
			})
			.catch(function(err) {
				removeStatus();
				if (typeof Facturavia !== 'undefined' && Facturavia.showNotification) {
					Facturavia.showNotification({
						message: 'Error al firmar con AutoFirma: ' + (err.message || 'Error desconocido') + '. Descargando sin firma...',
						type: 'warning'
					});
				}
				// Fallback: descargar sin firma
				window.open(href, '_blank');
			});
	}).catch(function() {
		removeStatus();
		// Si falla la carga del módulo, descargar sin firma
		window.open(href, '_blank');
	});
}, true);
